import { ProductHistory } from '@models/product';

/**
 * Returns tax paid when a product instance was purchased/received.
 * Uses FIFO when multiple purchase records exist (oldest unreturned purchase first).
 */
export function getPurchaseTaxFromHistory(history: ProductHistory[]): number {
  const purchase = getNextPurchaseFromHistory(history);
  return purchase?.product?.tax ?? 0;
}

export function getPurchaseShippingFromHistory(
  history: ProductHistory[]
): number {
  const purchase = getNextPurchaseFromHistory(history);
  return purchase?.product?.shipping ?? 0;
}

function getNextPurchaseFromHistory(
  history: ProductHistory[]
): ProductHistory | undefined {
  if (!history?.length) {
    return undefined;
  }

  const purchases = history
    .filter((entry) => entry.type === 'order')
    .sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
    );

  if (!purchases.length) {
    return undefined;
  }

  const returnCount = history.filter((entry) => entry.type === 'return').length;
  return purchases[returnCount] ?? purchases[purchases.length - 1];
}
